// write a type for the const below
export type VrModelProps = {
  averageViewDuration?: number | null;
  createDateTimeUtc?: string;
  creatorName?: string;
  label?: string;
  posterUrl?: string;
  referenceId?: string;
  revisionId?: string;
  status?: string;
  totalTourViews?: number | null;
  tourType?: string;
  tourUrl?: string;
  vrModelGuid?: string;
  vrModelId?: string;
};

const VrModel = ({
  averageViewDuration = null,
  createDateTimeUtc = '',
  creatorName = '',
  label = '',
  posterUrl = '',
  referenceId = '',
  revisionId = '',
  status = '',
  totalTourViews = null,
  tourType = '',
  tourUrl = '',
  vrModelGuid = '',
  vrModelId = '',
}: VrModelProps = {}) => ({
  averageViewDuration: Number(averageViewDuration),
  createDateTimeUtc: String(createDateTimeUtc),
  creatorName: String(creatorName),
  label: String(label),
  posterUrl: String(posterUrl),
  referenceId: String(referenceId),
  revisionId: String(revisionId),
  status: String(status),
  totalTourViews: Number(totalTourViews),
  tourType: String(tourType),
  tourUrl: String(tourUrl),
  vrModelGuid: String(vrModelGuid),
  vrModelId: String(vrModelId),
});

export default VrModel;
